
const handleDeclineSelector = document.getElementById('decline-btn-cok')
const handleAcceptSelector = document.getElementById('accept-btn-cok')

function getBannerEl() {
  return document.getElementById('cookies-banner');
}

function hideBanner(res) {
  getBannerEl().style.display = 'none';
}

function showBanner() {
  getBannerEl().style.display = 'block';
}
if(handleAcceptSelector != null) {
  handleAcceptSelector.addEventListener('click', handleAccept)
}
function handleAccept(e) {
  localStorage.setItem('kuki', 'kuki-acc')  
  window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);

  document.addEventListener('trackingConsentAccepted',function() {
    // console.log('trackingConsentAccepted event fired');
  });
}

if(handleDeclineSelector != null) {
  handleDeclineSelector.addEventListener('click', handleDecline)
}

function handleDecline() {
  window.Shopify.customerPrivacy.setTrackingConsent(false,hideBanner);
}

function initCookieBanner() {
  const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
  const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

  if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
    showBanner();
  }
}

window.Shopify.loadFeatures([
  {
    name: 'consent-tracking-api',
    version: '0.1',
  }
],
function(error) {
  if (error) {
    throw error;
  }

  initCookieBanner();
});

// cookies end
// banner slider
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {

  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });

  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });

  document.querySelectorAll('video').forEach((video) => video.pause());

  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
  
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {

  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.input.addEventListener('change', this.onInputChange.bind(this));

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }
  connectedCallback() {
    this.validateQtyRules();
  }
  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }

  
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};



Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }
      
      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('.product__media-icon_area');

    if (!button) return;

    button.addEventListener('click', () => {
      console.log(button);
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    // this.prevButton = this.querySelector('button[name="previous"]');
    // this.nextButton = this.querySelector('button[name="next"]');

    // if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    // this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    // this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    // if (this.isSlideVisible(this.sliderItemsToShow[0])) {
    //   this.prevButton.setAttribute('disabled', 'disabled');
    // } else {
    //   this.prevButton.removeAttribute('disabled');
    // }

    // if (this.isSlideVisible(this.sliderLastItem)) {
    //   this.nextButton.setAttribute('disabled', 'disabled');
    // } else {
    //   this.nextButton.removeAttribute('disabled');
    // }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    // this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }


  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if(mediaGallery != null){
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    }
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if(modalContent != null) {
      const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
       
          input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      
      }
    });
  }


  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
       
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        const infoOther =  document.querySelector('.other-categorys')
        const newinfoOther =  html.querySelector('.other-categorys')

        if(newinfoOther != null) {
          infoOther.innerHTML = newinfoOther.innerHTML
        }
        
         
        const upperBox =  document.querySelector('.product-single-right-box .upper-box')
        const newUpperBox =  html.querySelector('.product-single-right-box .upper-box')
        if(newUpperBox != null) {
          upperBox.innerHTML = newUpperBox.innerHTML
        }
        
        const description =  document.querySelector('.product-single-right-box .upper-box.sin-prd-item')
        const newDescription =  html.querySelector('.product-single-right-box .upper-box.sin-prd-item')
        if(newDescription != null) {
          description.innerHTML = newDescription.innerHTML
        }
        
      
        // const varint =  document.querySelector('.product-single-right-box .variant_picker-area')
        // const newVarint =  html.querySelector('.product-single-right-box .variant_picker-area')
        // if(newVarint != null) {
        //   varint.innerHTML = newVarint.innerHTML
        // }

        // const counter =  document.querySelector('.product-single-right-box .product-form__input')
        // const newCounter =  html.querySelector('.product-single-right-box .product-form__input')
        // if(newCounter != null) {
        //   counter.innerHTML = newCounter.innerHTML
        // }

        
        const appBlock =  document.querySelector('.product-single-right-box .main-product-appblock')
        const newAppBlock =  html.querySelector('.product-single-right-box .main-product-appblock')
        if(newAppBlock != null) {
          appBlock.innerHTML = newAppBlock.innerHTML
        }

        const oldInfoprice =  document.querySelector('.product-single-right-box .title-of-product')
        const newPrice =  html.querySelector('.product-single-right-box .title-of-product')
        if(newPrice != null) {
          oldInfoprice.innerHTML = newPrice.innerHTML
        }
        
        // const newSingleFpRight = this.offsetParent
        // if(newSingleFpRight != null) {
            
        //   const newSingleFpTitle =  html.querySelector('.pesto-single-fp-area .title-of-product')
        //   if(newSingleFpTitle != null) {
        //     newSingleFpRight.querySelector('.title-of-product').innerHTML = newSingleFpTitle.innerHTML
        //   }
        // }

      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;

    if (sku) sku.classList.add('visibility-hidden-sku');
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }


  

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


class SearchIconArea extends HTMLElement {
  constructor(){
    super()
    this.init()
    this.addEventListener('click', (event) => {
      event.preventDefault();
      document.body.classList.add('active-search')
      document.documentElement.classList.add('active-search-html')
      let inputField = this.nextElementSibling.querySelector('.search__input')
      setTimeout(function() { 
        inputField.focus()
      }, 100)
    });
    this.addEventListener('keydown', (e)=> {
      if (e.key === 'Escape') {
          e.preventDefault();
          document.body.classList.remove('active-search')
          document.documentElement.classList.remove('active-search-html')
      }
    });
  }
  init(){

  }
}
customElements.define('search-icon-area', SearchIconArea);

class SearchPopupArea extends HTMLElement {
  constructor(){
    super()
    this.searchBtn = this.querySelector('.button-search-uns');
    this.submitBtn = this.querySelector('.search__button');
    this.closeBtn = this.querySelector('.close-the-search');
    this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        document.documentElement.classList.remove('active-search-html')
        document.body.classList.remove('active-search')
        this.previousElementSibling.querySelector('.header-search-btn-click').focus()
    })
    this.addEventListener('keydown', (e)=> {
      if (e.key === 'Escape') {
          e.preventDefault();
          document.body.classList.remove('active-search')
          this.previousElementSibling.querySelector('.header-search-btn-click').focus()
      }
    });
    this.init()
  }

  init(){
    this.submitBtn.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && !e.shiftKey) {
            e.preventDefault();
            this.searchBtn.focus()
        }
    });
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') {
          e.preventDefault();
          let itemArea = this.querySelector('#predictive-search-results-list')
          if( itemArea != null ){
            let itemAreaLink = this.querySelector('#predictive-search-results-list .shop-block a')
            itemAreaLink.focus()
          }
      }
    });
  } 
}
customElements.define('search-popup-area', SearchPopupArea);

window.addEventListener('load', e => {
  const loaderRapper = document.querySelector('.loader-wrap')
  if( loaderRapper != null )
    loaderRapper.style.display = 'none';  
} )

const overlayHeader = document.querySelector('.overlay_header_area')
if( overlayHeader != null )
  document.body.classList.add('paddin-for-header')



  class FeaturePro extends HTMLElement {
    constructor() {
        super();
        this.getProduct = null
        this.onVariantChange()
        this.addEventListener('change', this.onVariantChange.bind(this))
    }
    onVariantChange() {
        const dataInfo = this.querySelector('.data-info-feature-product')
        const variant = JSON.parse(dataInfo.getAttribute('data-info'))

        
        const typeRadios = this.querySelector('.variant-radios-type')
        const typeSelects = this.querySelector('.variant-radios-selects')
       

        if(typeSelects != null) {
          const selectedValues = Array.from(this.querySelectorAll('select')).map(select => select.value);
          const selectedVariant = variant.find(variant => {
            return JSON.stringify(variant.options) === JSON.stringify(selectedValues)
          });
          if(selectedVariant != undefined){
            this.getProduct = selectedVariant.id
            this.priceUpdate(selectedVariant)
            this.imgUpdate(selectedVariant)
            this.skuUpdate(selectedVariant)
          }else{
            if(this.querySelector('.pesto-single-fp-content-sku') != null) this.querySelector('.pesto-single-fp-content-sku').classList.add('hide-item')
          }
        }

        if(typeRadios != null) {
          const radValues = Array.from(this.querySelectorAll('input[type=radio]')).filter(input => input.checked).map(input => {
            return input.value;
          });
          const selectedRadValues = variant.find(variant => {
            return JSON.stringify(variant.options) === JSON.stringify(radValues)
          });
          if(selectedRadValues != undefined){
              this.getProduct = selectedRadValues.id
              this.priceUpdate(selectedRadValues)
              this.imgUpdate(selectedRadValues)
              this.skuUpdate(selectedRadValues)
          }else{
            if(this.querySelector('.pesto-single-fp-content-sku') != null) this.querySelector('.pesto-single-fp-content-sku').classList.add('hide-item')
          }
        }
    
    }


    skuUpdate(dataPrd){
      if(dataPrd.sku != null){
        if(this.querySelector('.pesto-single-fp-content-sku') != null){
          this.querySelector('.pesto-single-fp-content-sku').classList.remove('hide-item')
          this.querySelector('.pesto-single-fp-content-sku-count').innerHTML = dataPrd.sku
        }
      }else{
        if(this.querySelector('.pesto-single-fp-content-sku') != null) this.querySelector('.pesto-single-fp-content-sku').classList.add('hide-item')
      }
    }
  
    priceUpdate(dataPrd){}
    imgUpdate(dataPrd){
      const img = this.querySelector('.pesto-single-fp-image-item img');
      if( dataPrd.featured_media != undefined){
        img.src = dataPrd.featured_media.preview_image.src
      }
    }

  }
  customElements.define('feature-pro', FeaturePro);


  /* global YT, Vimeo */
if (!customElements.get('youtube-vimio')) {
  class Video extends HTMLElement {
    constructor() {
      super();
      this.autoplay = this.dataset.autoplay;
      this.background = this.dataset.background === 'true';
      this.naturalWidth = this.dataset.naturalWidth === 'true';
    
      this.playInit = this.querySelector('.video-inner')
      this.handleResize = this.handleResize.bind(this);

      this.playInit.addEventListener('click', (e)=> {
        e.preventDefault();
        this.init();
        this.querySelector('.video-inner').classList.add('none');
 
      })
      
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
    }
    
    handleResize() {
        if (this.autoplay && !this.naturalWidth && this.iframe) {
        this.style.width = `${this.clientHeight * 1.7778}px`;
        }
    }

    connectedCallback() {
        // this.init();
        // window.addEventListener('resize', this.handleResize);
    }

    init() {
      const url = this.dataset.videoUrl;
      if (url) {
        if (url.includes('youtube.com')) {
          if (url.includes('v=')) {
            this.videoId = url.split('v=').pop().split('&')[0];
          } else {
            this.videoId = url.split('?')[0].split('/').pop();
          }
          
          this.type = 'youtube';
          this.initYouTube();
        } else if (url.includes('vimeo.com')) {
          this.videoId = url.split('?')[0].split('/').pop();
          this.type = 'vimeo';
          this.initVimeo();
        }
      } else {
        this.type = 'tag';
        this.initVideoTag();
      }
      // Allow for videos which haven't played to play on tap
      if (this.background) {
      //   this.closest('.video-section').addEventListener('click', this.play.bind(this));
      }
    }
    /**
     * Loads a player API script.
     * @param {string} src - Url of script to load.
     * @returns {Promise}
     */
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = src;
        s.onerror = reject;
        if (this.type === 'vimeo') s.onload = resolve;
        document.body.appendChild(s);
        if (this.type === 'youtube') {
          window.onYouTubeIframeAPIReady = () => resolve(window.YT);
        }
      });
    }
    /**
     * Initialises a YouTube video.
     */
    async initYouTube() {
      if (!window.YT) await this.loadScript('//www.youtube.com/iframe_api');
      YT.ready(() => {
        
        this.player = new YT.Player(this.querySelector('div'), {
          videoId: this.videoId,
          width: '1280',
          height: '720',
          playerVars: {
            controls: 1,
            disablekb: this.background ? 1 : 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            rel: 0
          },
          events: {
            onReady: this.handleYTReady.bind(this),
            onStateChange: this.handleYTStateChange.bind(this)
          }
        });
        
      });
    }
    /**
     * Initialises a Vimeo video.
     */
    async initVimeo() {
      if (!window.Vimeo) await this.loadScript('//player.vimeo.com/api/player.js');
      this.player = new Vimeo.Player(this, {
        id: this.videoId,
        width: '1280',
        height: '720',
        autoplay: this.autoplay,
        controls: true,
        title: true,
        byline: true,
        portrait: true
      });
      await this.player.ready();
      this.setupIframe('js-vimeo');
      this.player.on('pause', () => {
        if (this.inViewport) this.pausedByUser = true;
      });
      this.player.on('play', () => {
        this.closest('.video-section')?.classList.add('video-section--played');
      });
      this.play();
    }
    /**
     * Initialises a video tag.
     */
    initVideoTag() {
      this.player = this.querySelector('video');
      this.player.addEventListener('pause', () => {
        if (this.inViewport) this.pausedByUser = true;
      });
      // If the video is already playing
      if (this.player.currentTime > 0 && !this.player.paused && !this.player.ended
        && this.player.readyState > 2) {
        this.closest('.video-section')?.classList.add('video-section--played');
      } else {
        this.player.addEventListener('play', () => {
          this.closest('.video-section')?.classList.add('video-section--played');
        });
        this.addObserver(this.player);
        this.play();
      }
    }
    /**
     * Handles a YouTube ready event.
     */
    handleYTReady() {
      this.setupIframe('js-youtube');
      if (this.autoplay) this.player.mute();
      this.play();
    }
    /**
     * Handles a YouTube state change event.
     * @param {object} e - Event object.
     */
    handleYTStateChange(e) {
      if (e.data === YT.PlayerState.PAUSED) {
        if (this.inViewport) this.pausedByUser = true;
      } else if (e.data === YT.PlayerState.ENDED) {
        // Looping this way rather than 'loop' API parameter to avoid flash of black background
        if (this.background) this.player.playVideo();
      } else if (e.data === YT.PlayerState.PLAYING) {
        this.closest('.video-section')?.classList.add('video-section--played');
      }
    }
    /**
     * Sets up the injected iframe.
     * @param {string} jsClass - Class name to add to the iframe.
     */
    setupIframe(jsClass) {
      // Enable iframe to cover entire container height.
      if (this.autoplay && !this.naturalWidth) {
        this.style.width = `${this.clientHeight * 1.7778}px`;

      //   window.addEventListener('resize', window.debounce(() => {
      //     this.style.width = `${this.clientHeight * 1.7778}px`;
      //   }, 200));
      }

      this.iframe = this.querySelector('iframe');
      this.iframe.title = this.dataset.description;
      this.iframe.classList.add(jsClass);
      this.addObserver(this.iframe);
    }

    /**
     * Plays the video when scrolled into view (if not paused by the user).
     */
    play() {
      if (!this.player || this.pausedByUser) return;

      if (this.type === 'youtube') {
        this.player.playVideo();
      } else {
        this.player.play();
      }
    }

    /**
     * Pauses the video when scrolled out of view (if playing).
     */
    pause() {
      if (!this.player) return;

      if (this.type === 'youtube') {
        if (this.player.getPlayerState() !== 2) {
          this.player.pauseVideo();
          this.pausedByUser = false;
        }
      } else if (this.type === 'vimeo') {
        this.player.getPaused().then((paused) => {
          if (!paused) {
            this.player.pause();
            this.pausedByUser = false;
          }
        });
      } else if (!this.player.paused) {
        this.player.pause();
        this.pausedByUser = false;
      }
    }

    /**
     * Adds an observer to pause the video when not in the viewport.
     * @param {Element} el - Element to observe.
     */
    addObserver(el) {
      if ('IntersectionObserver' in window === false) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.inViewport = true;
            this.play();
          } else {
            this.inViewport = false;
            this.pause();
          }
        });
      });

      observer.observe(el);
    }
  }

  customElements.define('youtube-vimio', Video);
}

class mainHeader extends HTMLElement {
  constructor() {
    super()


    this.menuInner = this.querySelector('.has-mega-menu')

    this.scrollDown = this.classList.contains('scroll-down')
    this.scrollUp = this.classList.contains('scroll-up')
    
    
    this.currentScrollPosition = window.pageYOffset;
    this.lastScrollPosition =  window.pageYOffset

    this.menuInt()
    


    this.mobileMenuOpen =  this.querySelector('.mobile-menu')


    this.innerClose =  this.querySelector('.this-is-menu-hidden')
    if(this.innerClose){
      this.innerClose.addEventListener('click', this.menuClose.bind(this))
    }

    this.close =  this.querySelector('.close-btn')
    if(this.close){
      this.close.addEventListener('click', this.menuClose.bind(this))
    }

    this.menuBackdrop =  this.querySelector('.menu-backdrop')
    if(this.menuBackdrop){
      this.menuBackdrop.addEventListener('click', this.menuClose.bind(this))
    }

    this.toggleBtn =  this.querySelector('.mobile-nav-toggler')
    if(this.toggleBtn){
      this.toggleBtn.addEventListener('click', this.menuOpen.bind(this))
    }

    if(this.mobileMenuOpen){
      this.mobileMenuOpen.addEventListener('keydown', (e) => {

        if (e.key === 'Escape') {
            e.preventDefault();
            this.menuClose()
        }
      });
    }

    window.addEventListener('scroll', this.hanScr.bind(this));

  }
  disconnectedCallback() {
    // window.removeEventListener('scroll', this.hanScr.bind(this));
  }

  menuClose(){
    var htmlElement = document.querySelector('html');
    htmlElement.classList.remove('overflow-block-html');
    document.body.classList.remove('mobile-menu-visible')
    this.toggleBtn.focus()
  }
  
  menuOpen(){
    var htmlElement = document.querySelector('html');
    htmlElement.classList.add('overflow-block-html');

    document.body.classList.add('mobile-menu-visible')
    setTimeout(() => { 
      this.close.focus()
    }, 100)
  }

  menuInt(){
  
    var dropdownBtns = this.querySelectorAll('.dropdown');
    dropdownBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var dropdown = this.parentNode;
        dropdown.classList.toggle('open');
      });
    });

    var dropdownBtnsTwo = this.querySelectorAll('.dropdown-btn');
    dropdownBtnsTwo.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var dropdown = this.parentNode;
        dropdown.classList.toggle('open');
      });
    });

    var collapsibleDropdown = this.querySelectorAll('.collapsible-dropdown-prnt');
    collapsibleDropdown.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        this.closest('.collapsible-dropdown').classList.toggle('active');
      });
    });
    
    var collapsibleDropdownNext = this.querySelectorAll('.collapsible-dropdown-next');
    collapsibleDropdownNext.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        this.closest('.collapsible-dropdown').classList.toggle('active');
      });
    });
    
  }
  hanScr(){

    if(this.scrollDown){
      if (window.pageYOffset > 200) {
        this.classList.add("sticky");
      } 
      if (window.pageYOffset < 190){
        this.classList.remove("sticky");
      }
    }
    if(this.scrollUp){
        if (window.scrollY > this.lastScrollPosition) {
          this.classList.remove("sticky");
        }else{
          this.classList.add("sticky");
        }
        if(window.pageYOffset < 200) {
          this.classList.remove("sticky")
        }
        this.lastScrollPosition = window.scrollY;
    }

  }
}
customElements.define('main-header', mainHeader);



class SingleItemCollaps extends HTMLElement {
  constructor() {
    super();
    this.itemsList = this.querySelectorAll('.single-item');
    this.collapse();
  }

  collapse() {
    this.itemsList.forEach(item => {
      item.addEventListener('click', this.openClose.bind(item)); // Bind the item to maintain context
    });
  }

  openClose() {
    let openItem = this.classList.contains('open');
    let itemContent = this.querySelector('p');
    
    if (openItem) {
      this.classList.remove('open');
      itemContent.style.maxHeight = null; // Reset max-height for closing animation
    } else {
      this.classList.add('open');
      itemContent.style.maxHeight = itemContent.scrollHeight + "px"; // Set max-height for opening animation
    }
  }
}

customElements.define('single-item-collaps', SingleItemCollaps);


class QButton extends HTMLElement {
  constructor() {
    super();
    this.dataRif = document.querySelector('.data-m-x-rif')
    this.productUrl = this.dataset.product
    this.btn = this.querySelector('.qview')
    this.btn.addEventListener('click', this.onVariantChange.bind(this));
  }
  onVariantChange(){
    this.setAttribute('aria-disabled', true);
    this.classList.add('loading');

    const sectionUrl = `${this.productUrl.split('?')[0]}?view=quick-view`;
    console.log(sectionUrl);
    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.productElement = responseHTML.querySelector('.shop-details-modal-area');
        this.setInnerHTML(this.dataRif, this.productElement.innerHTML);
        setTimeout(() => {
          this.dataRif.classList.add('active-popup')
        }, 100);
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.classList.remove('loading');
      });
  }
  setInnerHTML(element, html) {
    element.innerHTML = html;

    element.querySelectorAll('script').forEach((oldScriptTag) => {
      
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);

      window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init()
    });
      
  }
}
customElements.define('q-button', QButton);

// Mega Menu
let dropdownLinks = document.querySelectorAll('.collapsible-dropdown-old > a');
  dropdownLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
          let parentItem = this.parentElement;
          parentItem.classList.toggle('active');
          event.preventDefault();
      });
});
   
function addHoverEffect() {
  let dropdownItems = document.querySelectorAll('.collapsible-dropdown');

  dropdownItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
          this.classList.add('active');
      });
      item.addEventListener('mouseleave', function () {
          this.classList.remove('active');
      });
  });
}
function addClickEffect() {
  let dropdownLinks = document.querySelectorAll('.collapsible-dropdown > a');
  dropdownLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
          let parentItem = this.parentElement;
          parentItem.classList.toggle('active');
          event.preventDefault(); 
      });
  });
}

/* 7th Heaven postcode gate - added 26 Sep 2026 - remove this block to revert */
(function(){
if(window.__TH_PC)return;window.__TH_PC=1;
var S=[["Aberdeen",57.1443,-2.1076,"aberdeen","252A Union St, Aberdeen AB10 1TN"],["Reading",51.4485,-0.9368,"reading","101 Wokingham Road, Reading RG6 1LH"],["Rugby",52.3736,-1.2595,"rugby","6 Albert St, Rugby CV21 2RS"],["Cotteridge",52.4164,-1.9290,"cotteridge","1865 Pershore Rd, Kings Norton B30 3DJ"],["Stanmore",51.6179,-0.3093,"stanmore","36 The Broadway, Stanmore HA7 4DU"],["Hale",53.3777,-2.3465,"hale","161b Ashley Road, Hale, Altrincham WA15 9SD"],["Hull",53.7444,-0.3405,"hull","13 King Edward St, Hull HU1 3RL"],["High Wycombe",51.6293,-0.7537,"highwycombe","Unit 83, Eden Shopping Centre, High Wycombe HP11 2DQ"]];
var MATCH=null;
var css="q-button.data-info-product,button.qview,pickup-availability,pickup-availability-preview{display:none!important}#th-pc{border:1px solid #e7ded3;border-radius:10px;background:#fdf7f1;padding:14px 16px;margin:14px 0}#th-pc h4{margin:0 0 4px;font-size:1rem;font-weight:700}#th-pc .sub{margin:0 0 10px;font-size:.87rem;color:#5c554b}#th-pc .row{display:flex;gap:8px;flex-wrap:wrap}#th-pc input{flex:1 1 150px;min-width:130px;padding:10px 12px;border:1px solid #d8cfc3;border-radius:8px;font-size:.95rem}#th-go{background:#e8541f;color:#fff;border:0;border-radius:8px;padding:10px 18px;font-weight:600;cursor:pointer}#th-res{margin-top:10px;font-size:.9rem;line-height:1.55}#th-res.ok{color:#2f5d50}#th-res.no{color:#a32c22}#th-res a.go{display:inline-block;margin-top:8px;background:#2f5d50;color:#fff;text-decoration:none;padding:10px 18px;border-radius:8px;font-weight:600}.th-lock{opacity:.45!important;cursor:not-allowed!important}.content-box-img figure.image{height:auto!important;aspect-ratio:4/5!important}.content-box-img figure.image img{object-fit:cover!important;height:100%!important;width:100%!important}";
css+=".icon-box:has(img[src*=eggless]){transform:scale(1.4)}.subscribe-section .shape-bg{filter:brightness(.45)}";
css+=".gallery-style-two .items-container .single-column,.gallery-block-two,.gallery-block-two .inner-box{height:auto!important}.gallery-block-two .inner-box{overflow:visible!important}.gallery-block-two .content-box{position:static!important;transform:none!important;padding:14px 6px 0!important;background:none!important;text-align:center!important}.gallery-block-two .content-box h2{margin:0!important}.gallery-block-two .content-box h2 span{font-size:19px!important;line-height:1.3!important}.gallery-block-two .all-ver-link{position:absolute!important;inset:0!important;width:auto!important;height:auto!important;z-index:5!important}";
css+=".gallery-block-two .image-box{height:400px!important;overflow:hidden!important;pointer-events:none!important}.gallery-block-two .image-box img{width:100%!important;height:100%!important;display:block!important;object-fit:cover!important}.gallery-block-two .content-box{opacity:1!important;visibility:visible!important;transform:none!important}.gallery-block-two .image-box img[src*='Chocolatestrawberrycake']{object-fit:contain!important}";
css+=".gallery-block-two:has(img[src*='Chocolatestrawberrycake']) .image-box,.gallery-block-two:has(img[src*='ChocoBrownieBites']) .image-box{filter:grayscale(1)!important;opacity:.5!important}.gallery-block-two:has(img[src*='Chocolatestrawberrycake']) .content-box,.gallery-block-two:has(img[src*='ChocoBrownieBites']) .content-box{opacity:.55!important}.gallery-block-two:has(img[src*='ChocoBrownieBites']) .content-box p{display:none!important}.gallery-block-two a.all-ver-link[href*='dietary-choices']{pointer-events:none!important;cursor:default!important}.gallery-block-two:has(img[src*='Chocolatestrawberrycake']) .inner-box,.gallery-block-two:has(img[src*='ChocoBrownieBites']) .inner-box{position:relative!important}.gallery-block-two:has(img[src*='Chocolatestrawberrycake']) .inner-box::after,.gallery-block-two:has(img[src*='ChocoBrownieBites']) .inner-box::after{content:'COMING SOON';position:absolute;top:200px;left:50%;transform:translate(-50%,-50%);background:rgba(0,0,0,.72);color:#fff;font-size:15px;font-weight:700;letter-spacing:2px;padding:10px 24px;border-radius:3px;z-index:9;pointer-events:none;white-space:nowrap}";
css+=".header-lower{background:#FBF0E4!important}.pesto-announcement-bar-custom-area{background:#FBF0E4!important}";
css+=".header-lower{background:transparent!important}.pesto-announcement-bar-custom-area{background:#E3F3FC!important}.header-layout-regular{background:linear-gradient(120deg,#D3EBFA 0%,#EAEFF6 45%,#FBE2E9 100%)!important}.nav-menu.style-two{background:linear-gradient(120deg,#F6E7CB 0%,#EFDCB2 55%,#E8CF9B 100%)!important;border-top:1px solid rgba(193,149,73,.45)!important}.nav-menu.style-two,.nav-menu.style-two a,.nav-menu.style-two span,.nav-menu.style-two div{color:#4A2A18!important}.nav-menu.style-two a{letter-spacing:.06em!important}";css+=".header-lower{background:#FFFFFF!important}.pesto-announcement-bar-custom-area{background:#FFFFFF!important}.header-layout-regular{background:#FFFFFF!important}.nav-menu.style-two{background:linear-gradient(120deg,#F6E7CB 0%,#EFDCB2 55%,#E8CF9B 100%)!important;border-top:1px solid rgba(193,149,73,.45)!important}.nav-menu.style-two,.nav-menu.style-two a,.nav-menu.style-two span,.nav-menu.style-two div{color:#4A2A18!important}.nav-menu.style-two a{letter-spacing:.06em!important}";css+=".body-for-index-template .shopify-section:has(.agrs__widget){background:#FAF2E4!important}.body-for-index-template .agrs__wrapper{padding:24px 0 20px!important}.body-for-index-template .agrs__widget-title{color:#4A2A18!important;font-size:26px!important}.body-for-index-template .agrs__card{border:2px solid transparent!important;border-radius:12px!important;background:linear-gradient(#fff,#fff) padding-box,linear-gradient(120deg,#E3C68A,#EFB9CE) border-box!important;box-shadow:0 8px 20px -10px rgba(74,42,24,.28)!important;height:238px!important;overflow:hidden!important}.body-for-index-template .agrs__card *{color:#4A3B33!important}.body-for-index-template [class*='agrs__card-photos']{max-height:70px!important;overflow:hidden!important}.body-for-index-template [class*='agrs__card-photos'] img{max-height:64px!important;width:auto!important}";if(location.hostname==="www.7thheavenbakery.co.uk"){css+=".agrs__shop-name{display:none!important}.agrs__summary__shop-photo{display:none!important}";}
var st=document.createElement("style");st.textContent=css;document.head.appendChild(st);
function dist(a,b,c,e){var p=Math.PI/180,x=(c-a)*p,y=(e-b)*p,h=Math.sin(x/2)*Math.sin(x/2)+Math.cos(a*p)*Math.cos(c*p)*Math.sin(y/2)*Math.sin(y/2);return 12742*Math.asin(Math.sqrt(h));}
function go(){
var i=document.getElementById("th-in"),r=document.getElementById("th-res");
var v=(i.value||"").trim();
if(!v){r.className="no";r.textContent="Please enter your postcode.";return;}
r.className="";r.textContent="Checking...";
fetch("https://api.postcodes.io/postcodes/"+encodeURIComponent(v)).then(function(x){return x.json();}).then(function(j){
if(!j||!j.result||typeof j.result.latitude!=="number"){r.className="no";r.textContent="We could not find that postcode. Please check it and try again.";return;}
var best=null,bd=1e9;
S.forEach(function(t){var d=dist(j.result.latitude,j.result.longitude,t[1],t[2]);if(d<bd){bd=d;best=t;}});
MATCH=best;
var mi=(bd*0.621371).toFixed(1);
r.className="ok";
r.innerHTML=NEAREST(best,mi);
apply();
}).catch(function(){r.className="no";r.textContent="Could not check right now. Please try again.";});
}
function NEAREST(b,mi){var a=document.createElement("a");a.className="go";a.href="https://"+b[3]+".7thheavenbakery.co.uk/";a.textContent="Order from "+b[0];return "<strong>Nearest store: 7th Heaven "+b[0]+"</strong><br>"+b[4]+" - about "+mi+" miles away<br>"+a.outerHTML;}
function findForm(){var fs=document.getElementsByTagName("form");for(var k=0;k<fs.length;k++){var a=(fs[k].getAttribute("action")||"");if(a.indexOf("/cart/add")>-1&&(fs[k].querySelector("[name=add]")||fs[k].querySelector("button[type=submit]")))return fs[k];}return null;}
function apply(){
cards();var f=findForm();if(!f)return;
var b=f.querySelector("[name=add]")||f.querySelector("button[type=submit]");if(!b)return;
if(location.pathname.indexOf("/products/")>-1&&!document.getElementById("th-pc")){
var w=document.createElement("div");w.id="th-pc";
var h4=document.createElement("h4");h4.textContent="Check your nearest store";
var p=document.createElement("p");p.className="sub";p.textContent="Enter your postcode to see where you can collect this cake.";
var row=document.createElement("div");row.className="row";
var inp=document.createElement("input");inp.id="th-in";inp.type="text";inp.placeholder="e.g. AB10 1TN";inp.setAttribute("autocomplete","postal-code");
var bt=document.createElement("button");bt.type="button";bt.id="th-go";bt.textContent="Check";
row.appendChild(inp);row.appendChild(bt);
var res=document.createElement("div");res.id="th-res";
w.appendChild(h4);w.appendChild(p);w.appendChild(row);w.appendChild(res);
var host=b.parentNode;if(host&&host.parentNode){host.parentNode.insertBefore(w,host);}else{b.parentNode.insertBefore(w,b);}
bt.addEventListener("click",go);
inp.addEventListener("keydown",function(e){if(e.key==="Enter"){e.preventDefault();go();}});
}
b.disabled=true;b.classList.add("th-lock");
}
function cards(){var q=document.querySelectorAll("q-button[data-product]");for(var i=0;i<q.length;i++){bindCard(q[i]);}}function boot(){apply();setInterval(apply,1200);}
function bindCard(b){var u=b.getAttribute("data-product");var p=b.parentNode;if(!u||!p)return;if(p.getAttribute("data-thlink"))return;p.setAttribute("data-thlink","1");p.style.cursor="pointer";p.addEventListener("click",function(e){if(e.target&&e.target.closest&&e.target.closest("a"))return;window.location.href=u;});}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",boot);}else{boot();}
})();
/* ---- 7th Heaven additions ---- */
(function () {
  var s = document.createElement('style');
  s.textContent =
      ".body-for-index-template .agrs__wrapper{padding:10px 0 8px!important}"
    + ".body-for-index-template .agrs__title-row{margin-bottom:4px!important}"
    + ".body-for-index-template .agrs__wrapper-inside{align-items:flex-start!important}"
    + ".body-for-index-template .agrs__summary{align-self:flex-start!important}"
    + ".body-for-index-template .agrs__card{height:200px!important}"
    + ".wa-float{position:fixed;right:20px;bottom:20px;width:55px;height:55px;border-radius:50%;background:#25D366;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 10px rgba(0,0,0,.25);z-index:9999}"
    + ".wa-float svg{width:30px;height:30px;fill:#fff;display:block}";
  document.head.appendChild(s);

  function init() {
    if (!document.querySelector('.wa-float')) {
      var a = document.createElement('a');
      a.className = 'wa-float';
      a.href = 'https://wa.me/447521038645';
      a.target = '_blank';
      a.rel = 'noopener';
      a.setAttribute('aria-label', 'Chat with us on WhatsApp');
      a.innerHTML = '<svg viewBox="0 0 32 32"><path d="M16 .396C7.164.396 0 7.56 0 16.396c0 2.885.75 5.593 2.062 7.937L.084 32l7.87-1.95A15.93 15.93 0 0016 32c8.836 0 16-7.164 16-16S24.836.396 16 .396zm0 29.24c-2.55 0-4.938-.664-7.013-1.822l-.5-.297-4.67 1.157 1.245-4.55-.325-.525A13.52 13.52 0 012.48 16.396c0-7.453 6.066-13.52 13.52-13.52s13.52 6.067 13.52 13.52-6.066 13.52-13.52 13.52zm7.51-10.08c-.41-.206-2.426-1.197-2.803-1.333-.376-.137-.65-.206-.923.206-.274.41-1.06 1.333-1.3 1.607-.24.274-.48.308-.89.103-.41-.206-1.73-.637-3.296-2.03-1.218-1.086-2.04-2.427-2.28-2.837-.24-.41-.026-.63.18-.836.185-.184.41-.48.616-.72.206-.24.274-.41.41-.684.137-.274.068-.513-.034-.72-.103-.206-.923-2.226-1.264-3.05-.332-.8-.67-.69-.923-.703-.24-.012-.513-.015-.787-.015s-.72.103-1.096.513c-.376.41-1.44 1.407-1.44 3.433s1.474 3.99 1.68 4.263c.206.274 2.9 4.43 7.026 6.21.982.423 1.747.675 2.344.864.984.313 1.88.27 2.588.164.79-.118 2.426-.99 2.77-1.948.343-.958.343-1.78.24-1.948-.103-.17-.376-.274-.787-.48z"/></svg>';
      document.body.appendChild(a);
    }
    document.querySelectorAll('a[href^="tel:"]:not([href="tel:+447520604653"])').forEach(function (el) {
      el.setAttribute('href', 'tel:+447521038645');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();/* ---- 7th Heaven: "need help ordering" strip on product pages ---- */
(function () {
  var PHONE = '+447521038645';
  var WA    = 'https://wa.me/447521038645?text=Hi%20I%20need%20help%20with%20my%20order';

  var s = document.createElement('style');
  s.textContent =
      ".checkout-help-strip{width:100%;flex:0 0 100%;box-sizing:border-box;background:#FAFAFA;border:1px solid #E5E5E5;border-radius:8px;padding:12px;margin:12px 0 0}"
    + ".checkout-help-strip p{font-size:13px;color:#333;text-align:center;margin:0 0 8px}"
    + ".checkout-help-strip .help-buttons{display:flex;gap:10px;justify-content:center;flex-wrap:wrap}"
    + ".checkout-help-strip .help-btn{font-size:13px;line-height:1.2;color:#fff!important;padding:9px 14px;border-radius:6px;text-decoration:none;display:inline-block}"
    + ".checkout-help-strip .call-btn{background:#000}"
    + ".checkout-help-strip .whatsapp-btn{background:#25D366}";
  document.head.appendChild(s);

  function addStrip() {
    var area = document.querySelector('.buy_buttons_area');
    if (!area) return;
    if (area.querySelector('.checkout-help-strip')) return;

    var d = document.createElement('div');
    d.className = 'checkout-help-strip';
    d.innerHTML =
        '<p>Having trouble checking out? We&rsquo;re here to help.</p>'
      + '<div class="help-buttons">'
      + '<a href="tel:' + PHONE + '" class="help-btn call-btn">Call Us</a>'
      + '<a href="' + WA + '" target="_blank" rel="noopener" class="help-btn whatsapp-btn">WhatsApp</a>'
      + '</div>';
    area.appendChild(d);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addStrip);
  } else {
    addStrip();
  }
})();/* ---- 7th Heaven: help strip typography polish ---- */
(function () {
  var s = document.createElement('style');
  s.textContent =
      ".checkout-help-strip{border-radius:10px!important;padding:14px!important}"
    + ".checkout-help-strip p{font-size:14px!important;margin:0 0 10px!important}"
    + ".checkout-help-strip .help-btn{font-size:12px!important;font-weight:700!important;text-transform:uppercase!important;letter-spacing:.05em!important;padding:11px 18px!important;border-radius:10px!important}"
    + ".checkout-help-strip .call-btn{background:#1F1F1F!important}";
  document.head.appendChild(s);
})();/* ---- 7th Heaven: reviews styling on ALL pages, not just the homepage ---- */
(function () {
  var s = document.createElement('style');
  s.textContent =
      ".shopify-section:has(.agrs__widget):not(:has(.shopify-section)){background:#FAF2E4!important}"
    + ".agrs__wrapper{padding:10px 0 8px!important}"
    + ".agrs__title-row{margin-bottom:4px!important}"
    + ".agrs__wrapper-inside{align-items:flex-start!important}"
    + ".agrs__summary{align-self:flex-start!important}"
    + ".agrs__widget-title{color:#4A2A18!important;font-size:26px!important}"
    + ".agrs__card{border:2px solid transparent!important;border-radius:12px!important;background:linear-gradient(#fff,#fff) padding-box,linear-gradient(120deg,#E3C68A,#EFB9CE) border-box!important;box-shadow:0 8px 20px -10px rgba(74,42,24,.28)!important;height:200px!important;overflow:hidden!important}"
    + ".agrs__card *{color:#4A3B33!important}"
    + "[class*='agrs__card-photos']{max-height:70px!important;overflow:hidden!important}"
    + "[class*='agrs__card-photos'] img{max-height:64px!important;width:auto!important}";
  document.head.appendChild(s);
})();/* ---- 7th Heaven: "Cakes Made Live" section + publications strip ---- */
(function () {
  var s = document.createElement('style');
  s.textContent =
      /* video keeps its true 696x1080 shape at any screen width - no cropping */
      ".best-selling-product .popup-video-container{height:auto!important;aspect-ratio:696/1080!important}"
    + ".best-selling-product .popup-video-container video{height:100%!important;width:100%!important;object-fit:contain!important}"
    + ".best-selling-product-video-inner{height:auto!important}"
    + ".best-selling-product-video{height:auto!important}"
      /* cream-gold ground so the section reads as its own block */
    + ".shopify-section.best-selling-product > .best-selling-product{background:#FAF2E4!important}"
      /* publications strip: true proportions, white ground to match the artwork */
    + ".banner-section.no-slider-area:has(.some-slider_item_mdFeP){height:auto!important;aspect-ratio:1193/191!important;padding:0!important;background:#FFFFFF!important}"
    + ".some-slider_item_mdFeP .shape img{object-fit:contain!important}"
      /* desktop only: tighter product carousel and heading */
    + "@media (min-width:992px){"
    +   ".best-selling-product .items-carousel-items img{height:215px!important;object-fit:cover!important}"
    +   ".best-selling-product .flickity-viewport{height:395px!important}"
    +   ".best-selling-product .section-title h2,.best-selling-product .section-title .h2{font-size:38px!important;line-height:1.1!important;margin-bottom:8px!important}"
    + "}";
  document.head.appendChild(s);
})();


/* ---- 7th Heaven: wording fixes (homepage tile, "Freshness Guaranteed", old WhatsApp number in FAQs) ---- */
(function () {
  var R = [
    [/GLUTEN FREE \/ VEGAN \/ SUGAR FREE/i, 'Alternative Flour / Vegan / No Added Sugar'],
    [/Freshness Guaranteed/i, 'Made Fresh in Store'],
    [/7308\s?473219/g, '7521 038645']
  ];
  function fix() {
    var w = document.createTreeWalker(document.body, 4), n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue, o = t;
      R.forEach(function (r) {
        t = t.replace(r[0], function (m) { return m === m.toUpperCase() ? r[1].toUpperCase() : r[1]; });
      });
      if (t !== o) n.nodeValue = t;
    }
    document.querySelectorAll('a[href*="7308473219"]').forEach(function (a) {
      a.href = a.href.replace('7308473219', '7521038645');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
  setTimeout(fix, 2500);
})();
 

/* ---- 7th Heaven: allergen line on every product page (above the buy buttons) ---- */
(function () {
  function addAllergenLine() {
    var anchor = document.querySelector('.buy_buttons_area');
    if (!anchor || document.querySelector('.allergen-line')) return;
    var p = document.createElement('p');
    p.className = 'allergen-line';
    p.textContent = 'Contains allergens and may also contain other allergens due to cross-contamination. If you, or anyone you are ordering for, has a food allergy, intolerance or coeliac disease, do not place an order. Full allergen information for any product is available from the store on request.';
    p.style.cssText = 'font-size:13px;line-height:1.4;color:#4A2A18;background:#FAF2E4;border:1px solid #E3C68A;border-radius:8px;padding:8px 12px;margin:0 0 12px;';
    anchor.parentNode.insertBefore(p, anchor);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addAllergenLine);
  else addAllergenLine();
})();
 

/* ---- 7th Heaven: allergen line on every product page (above the buy buttons) ---- */
(function () {
  function addAllergenLine() {
    var anchor = document.querySelector('.buy_buttons_area');
    if (!anchor || document.querySelector('.allergen-line')) return;
    var p = document.createElement('p');
    p.className = 'allergen-line';
    p.textContent = 'Contains allergens and may also contain other allergens due to cross-contamination. If you, or anyone you are ordering for, has a food allergy, intolerance or coeliac disease, do not place an order. Full allergen information for any product is available from the store on request.';
    p.style.cssText = 'font-size:13px;line-height:1.4;color:#4A2A18;background:#FAF2E4;border:1px solid #E3C68A;border-radius:8px;padding:8px 12px;margin:0 0 12px;';
    anchor.parentNode.insertBefore(p, anchor);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addAllergenLine);
  else addAllergenLine();
})();
 


/* ---- 7th Heaven: FAQ answers matched to the Refund & Cancellation Policy ---- */
(function () {
  var R = [
    ['If your order has been processed, it cannot be cancelled. We do not offer refunds, but we offer in-store credits with 3 months validity.',
     'Standard orders can be cancelled for a full refund at least 12 hours before your collection or delivery time, and customised orders at least 48 hours before. Please see our Refund & Cancellation Policy for full details.'],
    ['within 30mins of delivery on WhatsApp or on Email.', 'within 1 hour of collection or delivery, on WhatsApp or by email.'],
    ['If your order is already processed, it cannot be modified. We allow changes only within the next 10 mins after placing the order for express or same day delivery. For orders scheduled at a later date, please call us on',
     'Changes must be requested at least 12 hours before your collection or delivery time for standard orders, and at least 48 hours before for customised orders. Please call us on'],
    [', ONE day prior to inform the store manager of the same & check if your request can be accommodated.', '. We will do our best to accommodate later requests but cannot guarantee them.']
  ];
  function fix() {
    var w = document.createTreeWalker(document.body, 4), n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue, o = t;
      R.forEach(function (r) { t = t.split(r[0]).join(r[1]); });
      if (t !== o) n.nodeValue = t;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
  setTimeout(fix, 2500);
})();/* 7th Heaven tier drawing (Oct 2026) - draws stacked tiers with inch labels on tiered size options. Delete this block to revert. */
(function () {
  var RX = /^\s*((?:\d+"\s*\+\s*)+\d+")\s*·\s*approx\.\s*([\d.]+)\s*kg/i;
  function svg(t) {
    var W = 84, s = W / 14, h = 20, bh = 4, H = t.length * h + bh + 2, y = H - bh - h, out = '';
    t.forEach(function (d) {
      var w = d * s, x = (W - w) / 2;
      out += '<rect x="' + x.toFixed(1) + '" y="' + y + '" width="' + w.toFixed(1) + '" height="' + (h - 1) + '" rx="2" fill="#FFF6E5" stroke="#C9A44C" stroke-width="1"/>' +
        '<text x="' + (W / 2) + '" y="' + (y + h / 2 + 3.6) + '" text-anchor="middle" font-size="10.5" font-weight="700" font-family="inherit" fill="#7A5A1C">' + d + '&quot;</text>';
      y -= h;
    });
    var bw = (t[0] + 2) * s;
    out += '<rect x="' + ((W - bw) / 2).toFixed(1) + '" y="' + (H - bh) + '" width="' + bw.toFixed(1) + '" height="' + bh + '" rx="1.5" fill="#6FA8DC"/>';
    return '<svg class="tc-svg" width="' + W + '" height="' + H + '" viewBox="0 0 ' + W + ' ' + H + '" aria-hidden="true">' + out + '</svg>';
  }
  function apply() {
    document.querySelectorAll('.variant_picker-area label').forEach(function (l) {
      var b = l.querySelector('b:not(.tc-serves)');
      if (!b) return;
      var m = (b.textContent || '').match(RX);
      if (!m) return;
      var tiers = m[1].split('+').map(function (x) { return parseInt(x, 10); });
      var serves = '';
      l.querySelectorAll('i').forEach(function (i) {
        if (i.classList.contains('gs-cp') || i.classList.contains('tc-kg')) return;
        var mm = (i.textContent || '').match(/Serves\D*(\d+)/i);
        if (mm) { serves = mm[1]; i.remove(); }
      });
      l.querySelectorAll('.tc-svg,.tc-serves,.tc-kg').forEach(function (n) { n.remove(); });
      var wrap = document.createElement('span');
      wrap.innerHTML = svg(tiers) + '<b class="tc-serves">' + (serves ? 'Serves approx. ' + serves : m[1]) + '</b><i class="tc-kg">approx. ' + m[2] + 'kg</i>';
      b.replaceWith.apply(b, Array.prototype.slice.call(wrap.childNodes));
      l.classList.add('tc-label');
      l.setAttribute('aria-label', m[1] + ', approx. ' + m[2] + 'kg' + (serves ? ', serves ' + serves : ''));
    });
  }
  var css = document.createElement('style');
  css.textContent = '.tc-label{display:flex!important;flex-direction:column;align-items:center;gap:3px}' +
    '.tc-label svg.tc-svg{display:block!important;margin:2px auto 4px!important;width:84px!important;max-width:100%!important;height:auto!important;flex:none!important}' +
    '.tc-label .tc-serves{font-size:14px;font-weight:700;line-height:1.2}' +
    '.tc-label .tc-kg{font-style:normal;font-size:11.5px;opacity:.7;line-height:1.3}' +
    '.tc-label .gs-cp{font-style:normal}';
  document.head.appendChild(css);
  var queued = false;
  function queue() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; apply(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();